import { Bar, mixins } from 'vue-chartjs'
// import { isEmpty } from 'lodash'
import { commaFormatString } from '@/helpers'

export const types = {
  NORMAL: 'NORMAL',
  PERCENTAGE: 'PERCENTAGE'
}

const constructDatasets = function (datasets) {
  const newDatasets = []
  for (const d of datasets) {
    if (d.addMean) {
      let mean = d.addMean.mean
      if (!d.addMean.mean) {
        const sum = d.data.reduce((acc, val) => acc + val)
        mean = (sum / d.data.length)
      }
      const data = []
      for (let i = 0; i < d.data.length; i++) {
        data.push(mean)
      }
      newDatasets.push({
        label: 'Mean ' + d.label,
        type: 'line',
        data: data,
        fillColor: 'rgba(220,220,220,0.0)',
        strokeColor: 'rgba(220,220,220,1)',
        pointColor: 'rgba(220,220,220,1)',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(220,220,220,1)',
        yAxisID: 'lineGraph'
      })
    }
  }
  if (newDatasets.length > 0) {
    let original = datasets.splice(0, 1)
    datasets.push.apply(datasets, newDatasets)
    datasets.push.apply(datasets, original)
  }
}

export default Bar.extend({
  mixins: [mixins.reactiveProp],
  props: {
    labelFunc: Function,
    type: {
      type: String,
      default: types.NORMAL
    }
  },
  computed: {
    options () {
      const that = this
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barPercentage: 1,
            maxBarThickness: 300,
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7'
            },
            ticks: {
              fontSize: 14,
              display: true
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              zeroLineColor: '#0052E7'
            }
          }
          // TODO add when you need more than 1 line or bar on the chart
          // , {
          //   id: 'lineGraph',
          //   type: 'linear',
          //   position: 'right'
          // }
          ]
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function (tooltip, data) {
              if (that.labelFunc) {
                return that.labelFunc(tooltip, data)
              } else {
                let s = `${data.datasets[tooltip.datasetIndex].label}: ${commaFormatString(String(tooltip.yLabel))}`
                if (that.type === types.NORMAL) {
                  return s
                } else if (that.type === types.PERCENTAGE) {
                  return s + '%'
                }
              }
            }
          }
        }
      }
    }
  },
  mounted () {
    constructDatasets(this.chartData.datasets)
    this.renderChart(this.chartData, this.options)
  }
})



// WEBPACK FOOTER //
// ./src/app/components/graphs/BarGraph.js